import { quizStructure } from '../../utils/static-data/programQuiz'
import { retrieveFromStorage } from '../../utils/storage'

const sessions = retrieveFromStorage('quiz-sessions', {})
const currentSession = retrieveFromStorage('quiz-current-session', {})

const initialQuizState = {
  ...quizStructure,
  currentNode: quizStructure.initialNode,
  currentSession,
  previousNode: '',
  previousSession: {},
  sessions,
}

export default initialQuizState
